var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2501 0.666656H1.75008C1.52907 0.666656 1.31711 0.754454 1.16083 0.910734C1.00455 1.06701 0.916748 1.27898 0.916748 1.49999V16.5C0.916748 16.721 1.00455 16.933 1.16083 17.0892C1.31711 17.2455 1.52907 17.3333 1.75008 17.3333H8.83341V13.1667C8.83341 12.0183 9.76841 11.0833 10.9167 11.0833H15.0834V1.49999C15.0834 1.27898 14.9956 1.06701 14.8393 0.910734C14.6831 0.754454 14.4711 0.666656 14.2501 0.666656",
    fill: "#414B56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0833 13.1667V17.3333L15.0833 12.3333H10.9166C10.6956 12.3333 10.4836 12.4211 10.3273 12.5774C10.171 12.7337 10.0833 12.9457 10.0833 13.1667Z",
    fill: "#414B56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductList);
export default __webpack_public_path__ + "static/media/icon_product_list.50cc632a32fa7b8a679fd39725cf3075.svg";
export { ForwardRef as ReactComponent };